export type SubscriptionTier = 'free' | 'paid';
export type SubscriptionMethod = 'stripe' | 'app_store_subscription';

export interface SubscriptionState {
  tier: SubscriptionTier;
  subscriptionMethod?: SubscriptionMethod;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  subscriptionStatus?: 'active' | 'canceled' | 'past_due' | 'unpaid' | 'paused';
  assetLimit: number;
  paymentFailed?: boolean;
  billingInterval?: 'monthly' | 'yearly';
  cancelAtPeriodEnd?: boolean;
  currentPeriodEnd?: Date;

  // Apple IAP fields
  appleOriginalTransactionId?: string;
  appleProductId?: string;
  appleEnvironment?: 'Sandbox' | 'Production';
  appleSubscriptionStatus?: 'active' | 'expired' | 'billing_retry' | 'billing_grace_period' | 'revoked';
  appleExpiresDate?: Date;
  appleAutoRenewStatus?: boolean;
  appleGracePeriodExpiresDate?: Date;
  appleProcessedTransactions?: string[];
}

export const FREE_TIER_ASSET_LIMIT = 5;
export const PAID_TIER_ASSET_LIMIT = Infinity;

// Daily LLM token limit for paid users (100k tokens/day default)
export const DAILY_TOKEN_LIMIT = parseInt(process.env.DAILY_TOKEN_LIMIT || '100000', 10);
